import React from "react";

const variants = {
  active: {
    background: "rgba(34,197,94,0.14)",
    border: "1px solid rgba(34,197,94,0.35)",
    color: "#7ee39b",
  },
  success: {
    background: "rgba(34,197,94,0.14)",
    border: "1px solid rgba(34,197,94,0.35)",
    color: "#7ee39b",
  },
  warning: {
    background: "rgba(234,179,8,0.14)",
    border: "1px solid rgba(234,179,8,0.35)",
    color: "#f5c542",
  },
  danger: {
    background: "rgba(239,68,68,0.14)",
    border: "1px solid rgba(239,68,68,0.35)",
    color: "#ffb4b4",
  },
  info: {
    background: "rgba(59,130,246,0.16)",
    border: "1px solid rgba(59,130,246,0.35)",
    color: "#93c5fd",
  },
  neutral: {
    background: "rgba(148,163,184,0.14)",
    border: "1px solid rgba(148,163,184,0.25)",
    color: "#d7e7f5",
  },
};

export default function StatusPill({
  children,
  variant = "neutral",
  dot = false,
  style = {},
}) {
  const selected = variants[variant] || variants.neutral;

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        padding: "5px 10px",
        borderRadius: 999,
        fontSize: 12,
        fontWeight: 800,
        lineHeight: 1,
        whiteSpace: "nowrap",
        ...selected,
        ...style,
      }}
    >
      {dot && (
        <span
          style={{
            width: 7,
            height: 7,
            borderRadius: "50%",
            background: selected.color,
            display: "inline-block",
          }}
        />
      )}
      {children}
    </span>
  );
}
